import _ from 'lodash';
import Logger from 'logger';
import { API_V1 } from './APIs/APIv1';

export const reportFrontendError = async (
  path: string,
  error: { message: string; stack: string },
  userData: { tenant: string; id: string; email: string; firstName: string; lastName: string }
) => {
  try {
    const response = await API_V1.post('/misc/frontend-errors', {
      path,
      error,
      userData,
    });

    return response.data;
  } catch (e) {
    Logger.trace('Error while reporting frontend error!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};
